import React, { useState } from 'react';
import { Hero } from './components/Hero';
import { HookSection } from './components/HookSection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { WhatsInsideSection } from './components/WhatsInsideSection';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { BonusSection } from './components/BonusSection';
import { CredibilitySection } from './components/CredibilitySection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { PriceSection } from './components/PriceSection';
import { RiskReversalSection } from './components/RiskReversalSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { ScrollCTA } from './components/ScrollCTA';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
type Page = 'home' | 'terms' | 'privacy';
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const handleNavigate = (page: 'terms' | 'privacy') => {
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const handleBack = () => {
    setCurrentPage('home');
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  if (currentPage === 'terms') {
    return <TermsPage onBack={handleBack} data-id="element-0" />;
  }
  if (currentPage === 'privacy') {
    return <PrivacyPage onBack={handleBack} data-id="element-1" />;
  }
  return <div className="min-h-screen w-full bg-dark-bg font-inter antialiased" data-id="element-2">
      {/* Hook & Problem */}
      <Hero data-id="element-3" />
      <HookSection data-id="element-4" />
      <ProblemSection data-id="element-5" />

      {/* Solution & Value */}
      <MechanismSection data-id="element-6" />
      <WhatsInsideSection data-id="element-7" />

      {/* CTA #1 — Post value reveal: reader knows exactly what they get */}
      <ScrollCTA label="GET THE BLUEPRINT — $6.36" subtext="You now know exactly what's inside. One weekend. $500 in materials. A vault nobody can find." data-id="element-8" />

      {/* Trust & Proof */}
      <WhoIsThisFor data-id="element-9" />
      <CredibilitySection data-id="element-10" />
      <TestimonialsSection data-id="element-11" />

      {/* CTA #2 — Post social proof: trust is at its peak */}
      <ScrollCTA label="I'M READY — GET ACCESS NOW" subtext="Join thousands of gun owners who chose invisibility over a neon sign. 60-day guarantee, no questions asked." data-id="element-12" />

      {/* Objection Handling */}
      <FAQSection data-id="element-13" />

      {/* CTA #3 — Post FAQ: last objection removed, decision time */}
      <ScrollCTA label="SECURE YOUR COPY — $6.36" subtext="Every question answered. Every objection resolved. The only thing left is to act." data-id="element-14" />

      {/* Close — Bonuses shown immediately before price so buyer sees full order value */}
      <BonusSection data-id="element-15" />
      <PriceSection data-id="element-16" />
      <RiskReversalSection data-id="element-17" />
      <FinalCTA data-id="element-18" />

      {/* Footer */}
      <Footer onNavigate={handleNavigate} data-id="element-19" />
    </div>;
}